var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container-fluid bg-repeat",style:({ backgroundImage: _vm.dynamicBgImage, ..._vm.styleObject })},[(_vm.isStandardLayout)?_c('Sidebar'):_vm._e(),_c('router-view',{key:_vm.$route.path}),_c('Alert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }